<template>
  <Loader v-if="loading"></Loader>
  <div v-else>
    <Breadcrumb :items="items" />
    <noData v-if="noData" />
    <div class="form countryForm custom_card fadeIn" v-else>
      <ValidationObserver ref="formRiders" @submit.prevent="submit">
        <div class="row">
          <div class="d-flex gap-3 flex-wrap">
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('labels.refund_and_cancel_roles')"
              class="col-lg-12"
              rules="max:400|required"
            >
              <base-input
                v-model="value"
                col="12"
                type="ckeditor"
                :placeholder="$t('labels.refund_and_cancel_roles')"
              />
              <span v-if="errors[0]" class="error--text d-inline-block">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="button_wrapper center">
            <v-btn
              type="submit"
              @click="submit"
              :disabled="btnLoading"
              :loading="btnLoading"
            >
              {{ $t("submit") }}
            </v-btn>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "AcademySettings",
  props: {
    component_name: {
      type: String,
      required: true,
    },
    component_key: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      btnLoading: false,
      noData: false,
      value: "",
      loading: false,
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t(`breadcrumb.${this.component_name}.title`),
          disabled: false,
          href: "/admins/show-all",
        },
        {
          //   text: this.$t(`breadcrumb.policy.${this.id ? "edit" : "add"}`),
          text: this.$t(`breadcrumb.policy.refund_and_cancel`),
          disabled: true,
          href: "",
        },
      ],
    };
  },

  methods: {
    // Submit
    submit() {
      this.$refs.formRiders.validate().then((d) => {
        if (d) {
          this.btnLoading = true;

          // Create FormData
          let body = {
            settings: [
              {
                // key: this.component_name + "_refund_and_cancel",
                key: this.component_key,
                value: this.value,
              },
            ],
          };

          //   if (this.id) {
          //     data.append("_method", "PUT");
          //   }
          let url = "academy-settings/settings";
          //   if (this.id) {
          //     url = `coaches/${this.id}`;
          //   } else {
          //     url = "coaches";
          //   }

          let message = this.id
            ? this.$t("editSuccess")
            : this.$t("addSuccess");
          this.axios({
            method: "PUT",
            url: url,
            data: body,
          })
            .then(() => {
              this.$iziToast.success({
                title: this.$t("success"),
                message: message,
              });
              this.$router.push(`/${this.component_name}/show-all`);
              this.btnLoading = false;
            })
            .catch((err) => {
              const message = err.response.data.message;

              this.$iziToast.error({
                title: this.$t("error"),
                message: message,
              });

              this.btnLoading = false;
            });
        } else {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }
      });
    },
    // Main Edit Data
    async getEditData() {
      this.noData = false;
      this.loading = true;
      await this.axios({
        method: "GET",
        url: `academy-settings/settings`,
      })
        .then(async (res) => {
          let result = res.data.data;
          result = result.find((item) => item.key === this.component_key);
          this.value = (await result?.value) ?? "";
          this.loading = false;
          // console.log("result", result);
        })
        .catch((err) => {
          // console.log("err", err);
          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
          this.noData = true;
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getEditData();
  },
};
</script>

